
import { Avatar, Box, Grid, Stack, Tooltip, Typography } from "@mui/material";
import route from "../../../utils/Routes";
import { useNavigate } from "react-router-dom";
import ScrollBox from "../../../components/ScrollBox";
import { useQuery } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { getComListServ } from "../../../services/com-service";
import { useAuthContext } from "../../../context/AuthContext";
import { useEffect } from "react";
import { customAlert } from "../../../components/notify";
import { getFirstLetter, makeTxtOverFLow } from "../../../utils/format";
import constants from "../../../utils/Constants";
import shellLogo from '../../../assets/png/shell_logo.png'



function CompanyList() {
    const navigate = useNavigate();
    const { setLoadingScreen, setSelComValue, ctxtUser } = useAuthContext();
    const { data: comList, isLoading, isError, error } = useQuery([QueryKey.comList], () => getComListServ(),
        {
            cacheTime: 0, // Immediately clear the cache
            staleTime: Infinity, // Prevent automatic background refetching
        });

    useEffect(() => {
        if (isLoading) {
            setLoadingScreen(true);
        } else {
            setLoadingScreen(false);
        }
    }, [isLoading, setLoadingScreen]);

    useEffect(() => {
        setSelComValue({ comId: "", comName: "", comLogo: "" })
    }, [])

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }
    function handleComClick(comData) {
        const params = { comId: comData?.id };
        const queryString = new URLSearchParams(params).toString();
        navigate(ctxtUser?.userType === constants.accounts ? `${route.accPoTrackingList}?${queryString}` :
            `${route.amtcPoTrackingList}?${queryString}`)
    }

    return (
        <>
            <Stack direction={"row"} sx={{ mb: 1, mt: 1, width: '90%', alignItems: "center", justifyContent: "space-between" }}>
                <Typography sx={{ fontSize: 17, fontWeight: 500 }}> Company List</Typography>
            </Stack>
            <ScrollBox>
                {/* <Box sx={{ display: "flex", flexDirection: "row", flexGrow: 1, padding: "20px 24px", borderRadius: "16px", }}> */}
                {comList?.length === 0 ?
                    <Stack height={"100%"} mt={1} alignItems={"center"} justifyContent={"center"}>
                        <h2>Empty List</h2>
                    </Stack>
                    : <Grid container spacing={1}
                        direction="row"
                        justifyContent="start"
                        alignItems="center" mt={1}
                        pl={5}
                    >
                        {comList?.map((i) =>
                            <Box key={i.id} onClick={() => handleComClick(i)} sx={{
                                display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center",
                                padding: "16px", margin: "0 16px", backgroundColor: "white", borderRadius: "16px",
                                border: "1px solid rgba(0,0,0,0.1)", height: 200, width: 200, mb: 2,
                                cursor: "pointer",
                                transition: "transform 0.2s, box-shadow 0.2s, background-color 0.2s",
                                "&:hover": {
                                    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.2)",
                                    transform: "translateY(-4px)",
                                },
                                "&:active": {
                                    backgroundColor: "#e0e0e0", // Light gray effect on click
                                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                    transform: "translateY(2px)",
                                },
                            }}>
                                <Box sx={{
                                    width: 120, height: 120, borderRadius: 3, display: "flex", justifyContent: "center",
                                    alignItems: "center", border: "1px solid rgba(0,0,0,0.3)", boxShadow: 4, p: 1
                                }} loading="lazy" >

                                    {i.logo === "shell" ?   <img src={shellLogo} alt={`${i.name} logo`} style={{ width: 70 }} /> :
                                    <Avatar alt='profile_image' sx={{ height: "100%", width: "100%" }} variant="rounded" >
                                        {getFirstLetter(i.comName)} </Avatar>}
                                  

                                </Box>
                                <Tooltip title={i.comName}>
                                    <Typography sx={{ marginTop: 2, fontSize: 14, fontWeight: 400, color: "black" }}>
                                        {makeTxtOverFLow(i.comName, 18)}
                                    </Typography>
                                </Tooltip>
                            </Box>)}
                    </Grid>}

                {/* </Box> */}
            </ScrollBox>
        </>
    );
}

export default CompanyList;